import { Command, Plugin } from '@ckeditor/ckeditor5-core';
import { ButtonView } from '@ckeditor/ckeditor5-ui';
import { Widget, toWidget, toWidgetEditable, WidgetToolbarRepository } from '@ckeditor/ckeditor5-widget';

import Image from '@ckeditor/ckeditor5-image/src/image';
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar';
import ImageTextAlternative from '@ckeditor/ckeditor5-image/src/imagetextalternative';

import AddFolderImage from '../icons/AddFolder.svg';
import ImageFolderImage from '../icons/ImageFolder.svg';
import VideoFolderImage from '../icons/VideoFolder.svg';
import AudioFolderImage from '../icons/AudioFolder.svg';

import pencilIcon from '../icons/EditIcon.svg';
import deleteIcon from '../icons/DeleteIcon.svg';

var ckeditor;
var optionClass;

export default class ManageMedia extends Plugin {

   static get requires() {
      return [
         WidgetToolbarRepository,
         Image,
         ImageToolbar,
         ImageTextAlternative
      ];
   }

   init() {

      const editor = this.editor;
      ckeditor = this.editor;

      // Pulsante in modale
      $("#createGalleryButton").on("click", function () {
         createGalleryInCKEditor();
      });

      // Pulsanti in ckeditor
      createManageMediaButton(editor, "managemediaimage", ImageFolderImage, "Carica Immagine", "image");
      createManageMediaButton(editor, "managemediavideo", VideoFolderImage, "Carica Video", "video");
      createManageMediaButton(editor, "managemediaaudio", AudioFolderImage, "Carica Audio", "audio");
      createManageMediaButton(editor, "managemedia", AddFolderImage, "Carica Media", "");

      editor.commands.add('editMedia', new EditMediaCommand(editor));

      // Modello astratto e convertitori per galleria
      defineSchemaForGallery(editor);
      defineConvertersForGallery(editor);

      const widgetToolbarRepository = editor.plugins.get(WidgetToolbarRepository);
      widgetToolbarRepository.isEnabled = true;

      this._addEditButton();
      this._addDeleteButton();

      // Pulsanti per modifica e cancellazione galleria
      widgetToolbarRepository.register('gallery', {
         items: ['galleryEdit', 'galleryDelete'],
         getRelatedElement: selection => getClosestSelectedGalleryWidget(selection)
      });

      //#region Evento di cancellazione immagine in galleria 8deve cancellare anche galleryItem)

      editor.model.document.registerPostFixer(writer => {
         const changes = editor.model.document.differ.getChanges();
         let modelWasModifiedByPostFixer = false;

         for (const entry of changes) {
            // Controlla se un elemento 'imageBlock' è stato rimosso
            if (entry.type === 'remove' && entry.name === 'imageBlock') {
               // entry.position.parent è il genitore da cui il nodo è stato rimosso.
               const originalParent = entry.position.parent;

               if (originalParent && originalParent.is('element', 'galleryItem')) {
                  // Un imageBlock è stato rimosso da un galleryItem.
                  // Ora rimuoviamo questo galleryItem, ma solo se è ancora nell'albero del documento.
                  if (originalParent.parent) { // Assicura che galleryItem stesso non sia già stato rimosso.
                     console.log('[Gallery PostFixer Debug] Rimozione di galleryItem perché il suo imageBlock è stato cancellato:', originalParent.name, 'al percorso:', originalParent.path);
                     writer.remove(originalParent);
                     modelWasModifiedByPostFixer = true;
                  } else {
                     console.log('[Gallery PostFixer Debug] imageBlock rimosso da galleryItem, ma galleryItem è già scollegato dall\'albero:', originalParent.name);
                  }
               }
            }
         }
         return modelWasModifiedByPostFixer; // Restituisce true se questo post-fixer ha apportato modifiche
      });

      //#endregion

      //#region Disabilitare pulsanti per allineamento e ridimensionamento immagini

      const commandNamesToDisableInGallery = [
         'imageStyle',
         'resizeImage',
      ];

      commandNamesToDisableInGallery.forEach(commandName => {
         const command = editor.commands.get(commandName);
         const originalRefresh = command.refresh;
         command.refresh = function () {
            originalRefresh.apply(this, arguments);

            const model = editor.model;
            const selection = model.document.selection;
            const selectedElement = selection.getSelectedElement();

            if (selectedElement &&
               selectedElement.is('element', 'imageBlock') &&
               selectedElement.parent &&
               selectedElement.parent.is('element', 'galleryItem')) {
               this.isEnabled = false;
            }
         };
      });

      //#endregion

      //#region Limitazioni a drag and drop

      editor.editing.view.document.on('dragover', (evt, data) => {
         let targetElement = data.target;
         let isOverGallery = false;

         while (targetElement && !targetElement.is('rootElement') && !targetElement.hasClass('ck-editor__editable')) {
            if (targetElement.is('element', 'div') && targetElement.hasClass('ow-gallery') && targetElement.hasClass('ck-widget')) {
               isOverGallery = true;
               break;
            }
            targetElement = targetElement.parent;
         }

         if (isOverGallery) {
            data.dataTransfer.dropEffect = 'none';
            data.preventDefault();
            evt.stop();
         }
      }, { priority: 'highest' });

      editor.editing.view.document.on('drop', (evt, data) => {
         let targetElement = data.target;
         let isDroppedOnGallery = false;

         while (targetElement && !targetElement.is('rootElement') && !targetElement.hasClass('ck-editor__editable')) {
            if (targetElement.is('element', 'div') && targetElement.hasClass('ow-gallery') && targetElement.hasClass('ck-widget')) {
               isDroppedOnGallery = true;
               break;
            }
            targetElement = targetElement.parent;
         }

         if (isDroppedOnGallery) {
            data.dataTransfer.dropEffect = 'none';
            data.preventDefault();
            evt.stop();

            if (editor.plugins.has('Notification')) {
               editor.plugins.get('Notification').showWarning('Non è possibile rilasciare o modificare elementi qui tramite trascinamento.', {
                  title: 'Azione non permessa sulla galleria',
                  namespace: 'galleryTotalDropBlock'
               });
            }
         }
      }, { priority: 'highest' });

      let isDraggingFromGalleryInternals = false;

      editor.editing.view.document.on('dragstart', (evt, data) => {
         isDraggingFromGalleryInternals = false; // Resetta
         const targetViewElement = data.target;
         let modelElement = null;
         if (targetViewElement && targetViewElement.is('element')) {
            modelElement = editor.editing.mapper.toModelElement(targetViewElement);
            if (!modelElement && targetViewElement.is('element', 'img') && targetViewElement.parent && targetViewElement.parent.is('element', 'figure'))
               modelElement = editor.editing.mapper.toModelElement(targetViewElement.parent);
         }

         if (modelElement && modelElement.is('element', 'imageBlock') &&
            modelElement.parent && modelElement.parent.is('element', 'galleryItem')) {
            isDraggingFromGalleryInternals = true;

            try {
               data.dataTransfer.effectAllowed = 'none';
            } catch (e) {
            }
         }
      }, { priority: 'highest' });

      editor.editing.view.document.on('dragend', (evt, data) => {
         isDraggingFromGalleryInternals = false;
      }, { priority: 'lowest' });

      //#endregion

   }

   _addEditButton() {
      const editor = this.editor;

      editor.ui.componentFactory.add('galleryEdit', locale => {
         const button = new ButtonView(locale);

         const command = editor.commands.get('editMedia');

         button.set({
            label: 'Modifica Galleria',
            icon: pencilIcon,
            tooltip: true
         });

         if (command)
            button.bind('isEnabled').to(command);

         button.on('execute', () => {
            const selectedGalleryModel = this._getClosestSelectedGalleryMODELWidget(editor.model.document.selection);
            if (selectedGalleryModel)
               editor.execute('editMedia', selectedGalleryModel);
         });

         return button;
      });
   }

   _addDeleteButton() {
      const editor = this.editor;

      editor.ui.componentFactory.add('galleryDelete', locale => {
         const button = new ButtonView(locale);

         const command = editor.commands.get('editMedia');

         button.set({
            label: 'Cancella Galleria',
            icon: deleteIcon,
            tooltip: true
         });

         if (command)
            button.bind('isEnabled').to(command);

         button.on('execute', () => {
            const selectedGalleryModel = this._getClosestSelectedGalleryMODELWidget(editor.model.document.selection);
            if (selectedGalleryModel) {
               editor.model.change(writer => {
                  writer.remove(selectedGalleryModel);
               });
            }
         });

         return button;
      });
   }

   _getClosestSelectedGalleryMODELWidget(modelSelection) {
      const selectedModelElement = modelSelection.getSelectedElement();

      if (selectedModelElement && selectedModelElement.is('element', 'gallery'))
         return selectedModelElement;

      const position = modelSelection.getFirstPosition();

      if (position) {
         let parent = position.parent;
         while (parent) {
            if (parent.is('element') && parent.name == 'gallery')
               return parent;

            parent = parent.parent;
         }
      }

      return null;
   }
}

function createManageMediaButton(editor, name, icon, toolTip, _optionClass) {
   editor.ui.componentFactory.add(name, () => {

      // Creo il comando e lo aggiungo alla lista dei comandi (per poterlo disabilitare quando clicco codice sorgente) 
      const command = new ManageMediaCommand(editor);
      editor.commands.add(name, command);

      const button = new ButtonView();

      // Bindo onclick salvataggio ck (inserisce i media nell'editor)
      var modalSaveButton = document.querySelector('#modalManageMedia a.save-from-ck');
      modalSaveButton.addEventListener("click", insertFilesInCKEditor);

      button.set({
         class: 'ck-manage-media-button',
         icon: icon,
         tooltip: toolTip
      });

      button.bind('isOn', 'isEnabled').to(command, 'value', 'isEnabled');

      button.on('execute', () => {
         // Esegue il comando quando clicco il bottone
         optionClass = _optionClass;

         editor.execute(name);
      });

      return button;
   });
}


class ManageMediaCommand extends Command {
   execute() {
      ckeditor = this.editor;

      showModalMediaFromCkEditor(optionClass);
   }

   refresh() {
      this.isEnabled = true;
   }
}

class EditMediaCommand extends Command {
   execute(galleryModelElement) {
      const editor = this.editor;
      const mediaIds = this._getGalleryMediaIds(galleryModelElement);

      const handleGalleryUpdate = (updatedItems) => {
         if (!galleryModelElement || !galleryModelElement.root) {
            delete window.currentGalleryUpdateCallback;
            return;
         }

         editor.model.change(writer => {
            const childrenToRemove = Array.from(galleryModelElement.getChildren());
            if (childrenToRemove.length > 0) {
               for (const child of childrenToRemove) {
                  writer.remove(child);
               }
            }

            for (const itemData of updatedItems) {
               const galleryItem = writer.createElement('galleryItem');
               writer.setAttribute("mediaId", itemData.mediaId, galleryItem);

               const imageElement = writer.createElement('imageBlock', {
                  src: itemData.source,
                  alt: itemData.alt
               });

               writer.append(imageElement, galleryItem);
               writer.append(galleryItem, galleryModelElement);
            }
         });
         delete window.currentGalleryUpdateCallback;
      };

      window.currentGalleryUpdateCallback = handleGalleryUpdate;

      showModalMediaFromCkEditorForGallery(optionClass, mediaIds);
   }

   // Helper function to get all mediaId values from the gallery
   _getGalleryMediaIds(galleryElement) {
      const mediaIds = [];

      // Get all galleryItem elements within the gallery
      galleryElement.getChildren().forEach(galleryItem => {
         const mediaId = galleryItem.getAttribute('mediaId');
         if (mediaId) {
            mediaIds.push(mediaId);
         }
      });

      return mediaIds;
   }

   refresh() {
      const model = this.editor.model;
      const selection = model.document.selection;
      const selectedElement = selection.getSelectedElement();
      this.isEnabled = !!(selectedElement && selectedElement.is('element', 'gallery'));
   }
}

function insertFilesInCKEditor() {

   if ($("#modalManageMedia .media-list div.file.selected").length == 0)
      return;

   var action = "?action=insertFilesInCKEditor";
   var url = "/Modules/Media/ManageMedia2AjaxHandler.ashx" + action + manageMediaSectionId;

   $.post(url, {
      fileIds: mediaSelectedFileIds,
   }, function (data) {
      if (!AjaxError(data)) {

         const viewFragment = ckeditor.data.processor.toView(data);
         const modelFragment = ckeditor.data.toModel(viewFragment);
         ckeditor.model.insertContent(modelFragment);

         closeModalManageMedia();
      }
   });
}


function createGalleryInCKEditor() {
   ckeditor.model.change(writer => {
      const galleryElement = _createGallery(writer);
      if (galleryElement && galleryElement.childCount > 0)
         ckeditor.model.insertObject(galleryElement, null, null, { findOptimalPosition: 'auto' });

      if (typeof closeModalManageMedia === "function")
         closeModalManageMedia();
   });
}


function _createGallery(writer) {

   var action = "?action=createGalleryInCKEditor";
   var url = "/Modules/Media/ManageMedia2AjaxHandler.ashx" + action + manageMediaSectionId;

   var galleryModelElement = writer.createElement('gallery');

   $.ajax({
      type: "POST",
      url: url,
      async: false,
      data: {
         fileIds: mediaSelectedFileIds,
      },
      success: function (data) {

         if (!AjaxError(data)) {

            const itemsData = data.split('~');

            for (var i = 0; i < itemsData.length; i++) {

               if (!itemsData[i])
                  continue;

               var _data = itemsData[i].split("|");

               if (_data.length < 2)
                  continue;

               var mediaId = _data[0];
               var imagesrc = _data[1];
               var alt = _data[2];
               var caption = _data[3];

               const galleryItem = writer.createElement('galleryItem');
               writer.setAttribute("mediaId", mediaId, galleryItem);

               const imageElement = writer.createElement('imageBlock', {
                  src: imagesrc,
                  alt: alt
               });

               writer.append(imageElement, galleryItem);

               if (caption && caption.trim() !== '') {
                  const captionElement = writer.createElement('caption');
                  const captionContentTextNode = writer.createText(caption);

                  writer.append(captionContentTextNode, captionElement);
                  writer.append(captionElement, imageElement);
               }

               writer.append(galleryItem, galleryModelElement);
            }
         }
      }
   });

   return galleryModelElement;
}

function defineSchemaForGallery(editor) {

   const schema = editor.model.schema;

   //#region Galleria

   schema.register('gallery', {
      isObject: true,
      allowWhere: '$block',
      allowChildren: 'galleryItem'
   });

   //#endregion

   //#region GalleryItem

   schema.register('galleryItem', {
      allowIn: ['gallery', 'block'],
      allowAttributes: ['mediaId'],
      allowChildren: ['imageBlock']
   });

   //#endregion

   //#region Immagine

   if (schema.isRegistered('imageBlock')) {
      schema.extend('imageBlock', {
         allowIn: 'galleryItem'
      });
   }

   //#endregion

   schema.addChildCheck((context, childDefinition) => {
      if (context.endsWith('galleryItem') && childDefinition.name == 'gallery')
         return false;
   });
}

function defineConvertersForGallery(editor) {

   const conversion = editor.conversion;

   //#region Galleria

   conversion.for('upcast').elementToElement({
      model: 'gallery',
      view: {
         name: 'div',
         classes: ['ow-gallery', 'owl-carousel']
      },
      converterPriority: 'high'
   });

   conversion.for('dataDowncast').elementToElement({
      model: 'gallery',
      view: {
         name: 'div',
         classes: ['ow-gallery', 'owl-carousel']
      }
   });

   conversion.for('editingDowncast').elementToElement({
      model: 'gallery',
      view: (modelElement, { writer: viewWriter }) => {
         const div = viewWriter.createContainerElement('div', { class: 'ow-gallery owl-carousel' });

         return toWidget(div, viewWriter, { label: 'gallery widget' });
      }
   });

   //#endregion

   //#region GalleryItem

   conversion.for('upcast').elementToElement({
      view: {
         name: 'div',
         classes: 'ow-gallery-item'
      },
      model: (viewElement, { writer: modelWriter }) => {
         const mediaId = viewElement.getAttribute('media-id');

         return modelWriter.createElement('galleryItem', {
            mediaId: mediaId
         });
      },
      converterPriority: 'high'
   });

   conversion.for('dataDowncast').elementToElement({
      model: 'galleryItem',
      view: (modelElement, { writer: viewWriter }) => {
         return viewWriter.createContainerElement('div', {
            class: 'ow-gallery-item',
            'media-id': modelElement.getAttribute('mediaId')
         });
      }
   });

   conversion.for('editingDowncast').elementToElement({
      model: 'galleryItem',
      view: (modelElement, { writer: viewWriter }) => {
         return viewWriter.createContainerElement('div', {
            class: 'ow-gallery-item',
            'media-id': modelElement.getAttribute('mediaId')
         });
      }
   });

   //#endregion

   //#region Image

   conversion.for('upcast').elementToElement({
      view: {
         name: 'img',
         classes: 'ow-gallery-img'
      },
      model: (viewImg, { writer: modelWriter }) => {
         return modelWriter.createElement('imageBlock', {
            src: viewImg.getAttribute('src'),
            alt: viewImg.getAttribute('alt')
         });
      },
      converterPriority: 'highest' // Priorità alta per intercettare ow-gallery-img
   });

   conversion.for('dataDowncast').add(dispatcher => {
      dispatcher.on('insert:imageBlock', (evt, data, conversionApi) => {
         const modelElement = data.item;

         // Controlla se imageBlock è dentro un galleryItem
         if (modelElement.parent && modelElement.parent.name === 'galleryItem') {
            const viewWriter = conversionApi.writer;
            const viewFigure = conversionApi.mapper.toViewElement(modelElement);
            const viewImg = findDescendantImg(viewFigure);
            if (viewImg) {
               viewWriter.addClass('ow-gallery-img', viewImg);
            }
         }
      }, { priority: 'low' }); // Esegui dopo il converter di default
   });

   //#endregion

}

// Funzione helper per trovare <img> discendente (usata nel dataDowncast d'esempio)
function findDescendantImg(viewElement) {
   if (!viewElement) return null;
   if (viewElement.is('element', 'img')) {
      return viewElement;
   }
   for (const child of viewElement.getChildren()) {
      if (child.is('element')) {
         const img = findDescendantImg(child);
         if (img) return img;
      }
   }
   return null;
}


function getClosestSelectedGalleryWidget(viewSelection) {
   const selectedViewElement = viewSelection.getSelectedElement();

   if (selectedViewElement && isGalleryWidget(selectedViewElement))
      return selectedViewElement;

   let currentElement = viewSelection.getFirstPosition() ? viewSelection.getFirstPosition().parent : null;
   while (currentElement) {
      if (isGalleryWidget(currentElement)) {
         return currentElement;
      }
      currentElement = currentElement.parent;
   }
   return null;
}


function isGalleryWidget(viewElement) {
   return !!(viewElement && viewElement.is('element', 'div') && viewElement.hasClass('ow-gallery') && viewElement.hasClass('ck-widget'));
}